// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/orders/NewOrderModal/NewOrderPaymentsForm/test.css
// module id = 1903
// module chunks = 0